import React from "react";

const SEOFeatureHighlights = () => {
  const featureHighlights = [
    {
      title: "Affordable SEO Services",
      desc: "We offer search engine optimization services at affordable price. Cheapest price in the industry.",
      btnStatus: "btn-soft-danger",
    },
    {
      title: "Self-Serve SEO Panel",
      desc: "Promote & rank your web sites with our easy to use self-serve SEO panel in just a few minutes.",
      btnStatus: "btn-soft-primary",
    },
    {
      title: "Simple Campaign Creation",
      desc: "Creating and running your campaign can take a few minutes. Save your time with our SEO platform.",
      btnStatus: "btn-soft-success",
    },
  ];
  return (
    <div className="row">
      {featureHighlights?.map((data, id) => (
        <div className="col-md-4 mb-7" key={id}>
          <div className="text-center px-lg-3">
            <span
              className={`btn btn-icon btn-lg ${data.btnStatus} rounded-circle mb-5`}
            >
              <span className="fab fa-yelp fa-2x btn-icon__inner btn-icon__inner-bottom-minus"></span>
            </span>
            <h3 className="h5">{data.title}</h3>
            <p className="mb-md-0">{data.desc}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SEOFeatureHighlights;
